import { GetGoodsSpecificationInfoService } from './api-services/get-goods-specification-info.service';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KYMW1105Component } from './kymw1105.component';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { SharedModule } from '../../../shared/shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';

/**
 * eBASEデータ画面 モジュール設定クラス
 *
 * @export KYMW1105Module
 * @class KYMW1105Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    SharedModule,
    AppCommonsModule,
    WjInputModule,
    WjNavModule,
    WjGridModule
  ],
  declarations: [
    KYMW1105Component,
  ],
  providers: [
    GetGoodsSpecificationInfoService
  ],

})
export class KYMW1105Module { }
